var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contact-content-content",domProps:{"innerHTML":_vm._s(_vm.gbl.content.contact)}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stamp"},[_c('img',{attrs:{"src":require("../../images/stamp.png")}})])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c5cb5d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/pages/ContactPage.vue
// module id = 4HZP
// module chunks = 0